var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":"","row":"","wrap":""}},[_c('v-progress-circular',{attrs:{"size":50,"color":"black","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }